module.exports = __webpack_public_path__ + "static/media/trim-donut-o.9954b071.png";